import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { TreetopPropertiesProvider } from 'shared/util-common';

import { TaxonomyDto } from '@treetop/shared/model';

import { LoadingService } from '../infrastructure/loading.service';
import { MessagesService } from '../infrastructure/messages.service';

@Injectable({
  providedIn: 'root',
})
export class TreeStore {
  private http = inject(HttpClient);
  private loading = inject(LoadingService);
  private messages = inject(MessagesService);

  baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api`;

  private treetopTaxonomySubject$ = new BehaviorSubject<TaxonomyDto[]>([]);
  public currentTaxonomySubject$ = new BehaviorSubject<TaxonomyDto[]>([]);
  currentTaxonomy$: Observable<TaxonomyDto[]> = this.currentTaxonomySubject$.asObservable();

  public setTreetopTaxonomy(): void {
    this.treetopTaxonomySubject$.subscribe((treetopTaxonomy) => {
      this.currentTaxonomySubject$.next(treetopTaxonomy);
    });
  }

  public loadTreetopTaxonomy(): void {
    const loadTree$ = this.http.get<TaxonomyDto[]>(`${this.baseUrl}/taxonomies`).pipe(
      catchError((err) => {
        this.messages.showError('CouldNotLoadTaxonomy');
        return throwError(() => err);
      }),
      tap((tree) => {
        this.treetopTaxonomySubject$.next(tree);
      }),
    );
    this.loading.showLoaderUntilCompleted(loadTree$).subscribe();
  }

  private searchTree(nodeId: string, parent: TaxonomyDto): string[] {
    const stack = [[parent, [parent.title]]];
    while (stack.length) {
      let [node, path] = stack.pop();
      node = node as TaxonomyDto;
      path = path as string[];
      if (node.id === nodeId) {
        return path;
      }
      if (node.children) {
        // eslint-disable-next-line
        // @ts-ignore
        stack.push(...node.children.map((n) => [n, [...path, n.title]]));
      }
    }
  }

  getBreadcrumb(node: TaxonomyDto): string[] {
    if (node) {
      const root = {
        id: 'null',
        title: 'All',
        children: this.currentTaxonomySubject$.getValue(),
      };
      return this.searchTree(node.id, root);
    }
    return ['All'];
  }
}
